<template>
  <div id="loading" class="loading-ls"></div>
</template>

<script>
  export default {
    name: "Spinner",
  }
</script>

<style scoped>
  .loading-ls {
    border: 3px solid var(--btn-box-shadow-color) !important;
    border-top-color: var(--accent-color) !important;

  }

  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(54, 163, 247, 0.3);
    border-radius: 50%;
    border-top-color: #36a3f7;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }

  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
</style>
